<template>
    <nav
        class="pagination is-centered"
        role="navigation"
        aria-label="pagination"
    >
        <a
            v-if="!hideControls"
            v-t="'pagination_previous'"
            :disabled="currentPage == 1"
            class="pagination-previous"
            @click="currentPage > 1 && $emit('pagechanged', currentPage - 1)"
        ></a>
        <ul class="pagination-list">
            <li v-if="paginationTriggers[0] > visiblePagesCount - 2">
                <a
                    :aria-label="`Goto
            page
            ${1}`"
                    class="pagination-link"
                    @click="$emit('pagechanged', 1)"
                    >{{ 1 }}</a
                >
            </li>
            <li v-if="paginationTriggers[0] > visiblePagesCount - 2">
                <a class="pagination-ellipsis">&hellip;</a>
            </li>
            <li v-for="page in paginationTriggers" :key="page">
                <a
                    :class="{ 'is-current': currentPage == page }"
                    :aria-label="`Goto
            page
            ${page}`"
                    class="pagination-link"
                    @click="$emit('pagechanged', page)"
                    >{{ page }}</a
                >
            </li>
            <li v-if="currentPage < pageCount - visiblePagesCount + 2">
                <a class="pagination-ellipsis">&hellip;</a>
            </li>
            <li
                v-if="
                    currentPage < pageCount - visiblePagesCount + 2 ||
                    (pageCount < visiblePagesCount && currentPage != pageCount)
                "
            >
                <a
                    :aria-label="`Goto
            page
            ${pageCount}`"
                    class="pagination-link"
                    @click="$emit('pagechanged', pageCount)"
                    >{{ pageCount }}</a
                >
            </li>
        </ul>

        <a
            v-if="!hideControls"
            v-t="'pagination_next'"
            :disabled="currentPage == pageCount"
            class="pagination-next"
            @click="
                currentPage < pageCount && $emit('pagechanged', currentPage + 1)
            "
        ></a>
    </nav>
</template>

<script>
export default {
    props: {
        currentPage: {
            type: Number,
            required: true,
        },
        pageCount: {
            type: Number,
            required: true,
        },
        visiblePagesCount: {
            type: Number,
            default: 5,
        },
        hideControls: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        paginationTriggers() {
            const currentPage = this.currentPage;
            const pageCount = this.pageCount;
            const visiblePagesCount = Math.min(
                this.visiblePagesCount,
                this.pageCount
            );

            const visiblePagesThreshold = (visiblePagesCount - 1) / 2;

            if (visiblePagesThreshold === 0) {
                return [1];
            }
            const paginationTriggersArray = Array(visiblePagesCount - 1).fill(
                0
            );

            if (currentPage <= visiblePagesThreshold + 1) {
                paginationTriggersArray[0] = 1;
                const paginationTriggers = paginationTriggersArray.map(
                    (paginationTrigger, index) => {
                        return paginationTriggersArray[0] + index;
                    }
                );
                // paginationTriggers.push(pageCount);
                return paginationTriggers;
            }

            if (currentPage >= pageCount - visiblePagesThreshold) {
                const paginationTriggers = paginationTriggersArray.map(
                    (paginationTrigger, index) => {
                        return pageCount - index;
                    }
                );
                paginationTriggers.reverse().unshift(1);
                return paginationTriggers;
            }

            paginationTriggersArray[0] = currentPage; // - visiblePagesThreshold + 1;
            const paginationTriggers = paginationTriggersArray.map(
                (paginationTrigger, index) => {
                    return paginationTriggersArray[0] + index;
                }
            );
            //paginationTriggers[paginationTriggers.length - 1] = pageCount;
            return paginationTriggers;
        },
    },
};
</script>

<style></style>
